<template>
  <div>
    <el-form v-model="formData" label-width="70px" size="small">
      <el-row :gutter="10">
        <el-col :span="10">
          <el-form-item :label="'开始日期'">
            <el-date-picker
              v-model="formData.planStartDate"
              type="date"
              size="small"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择计划开始日期'"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="'结束日期'">
            <el-date-picker
              v-model="formData.planEndDate"
              type="date"
              size="small"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择计划结束日期'"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-primary"
            @click="query()"
          >
            {{ $l('INDEX.btn_search') || '搜索' }}
          </b-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  inject: ['loadGantt'],
  data() {
    return { formData: {} }
  },
  methods: {
    query() {
      this.loadGantt(this.formData)
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form .el-form-item {
  margin-bottom: 0 !important;
}
</style>
